export default __webpack_public_path__ + "static/reddit-7e6262d0013e083557b439104ed48ecb.png";